 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";

const PropertyInfiniteScrollContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" gridSize={3} scrollType="infinite" carShow={9} />
    </>
  );
};

export default PropertyInfiniteScrollContainer;
